export default {
  RequiredUserName: 0, // Trống tên đăng nhập
  RequiredPassword: 5, // Trống mật khẩu
  RequiredConfirmedPassword: 10, // Trống mật khẩu nhập xác nhận
  RequiredPhoneNumber: 15, // Trống số điện thoại đăng ký
  ExistedUserName: 20, // Tên đăng nhập đã tồn tại
  PasswordMismatch: 25, // Mật khẩu xác nhận không trùng khớp
  PasswordNotRequiredLength: 30, // Mật khẩu không đủ độ dài ký tự
  PasswordNotRequireDigit: 35, // Mật khẩu không chứa ký tự số
  PasswordNotRequireLowercase: 40, // Mật khẩu không chứa ký tự viết thường
  PasswordNotRequireUppercase: 55, // Mật khẩu không chứa ký tự viết hoa
  PasswordNotRequireNonAlphanumeric: 50, // Mật khẩu không chứa ký tự đặc biệt
  PasswordNotRequiredUniqueChars: 55, // Số ký tự đặc biệt trong mật khẩu không đủ
  InvalidUserName: 60, // Tên đăng nhập không tồn tại
  InvalidPassword: 65, // Sai mật khẩu đăng nhập
  InvalidAccount: 70, // Tên đăng nhập hoặc mật khẩu sai
  InvalidEmail: 75, // Email không hợp lệ
  InvalidPhoneNumber: 80, // Số điện thoại không hợp lệ
  ExistedEmail: 85, // Email đã tồn tại
  InvalidForgotPhoneNumber: 83, // Số điện thoại quên mật khẩu không hợp lệ
  InvalidForgotEmail: 87, // Email quên mật khẩu không tồn tại
  InvalidOTP: 90, // Mã OTP người dùng nhập không hợp lệ
  ExpireOTP: 95, // Mã OTP hết hạn
  LimitTimeOTP: 100, // Nhập OTP quá số lần cho phép
  UndefinedError: 999, // Lỗi chưa xác định
}
